import { BaseError } from '../../../errors/base.js';

class AggregatedQuoteError extends BaseError {
    constructor({ errors, }) {
        super("Aggregated quote error", {
            cause: errors,
            name: "AggregatedQuoteError",
        });
        this.errors = errors;
    }
}

export { AggregatedQuoteError };
//# sourceMappingURL=aggregatedQuoteError.js.map
